import React from 'react';
import {Grid, Card} from '@material-ui/core';
import {T} from 'Actions/translate';
import BasicInput from 'Components/common/BasicInput';
import {Description} from '@material-ui/icons';
import SelectInput from 'Components/common/SelectInput';
import util from 'Utils/commonUtil';
import Anchor from 'Components/common/Anchor';
import BasicOnInput from 'Components/common/BasicOnInput';
import {loadLanguage} from 'Utils/jwtUtil';

class BillToConfirm extends React.Component {
    state = {
        billToPhoneDisable: false,
        isChangeBillToConsignee: false,
    };

    handleSearch = (name, value, serachFlg) => {
        this.setState({
            [name]: value,
            billToPhoneDisable: serachFlg,
            isChangeBillToConsignee: true,
        });
        this.props.handleSearch(name, value, serachFlg);
    };

    render() {
        const {
            shipToInfo,
            receiver,
            receiverTel,
            billToPhone,
            billToConsignee,
            invoiceReceiverEmail,
            billToEmail,
            stContactList,
            isProxyProcess,
        } = this.props;
        const {billToPhoneDisable, isChangeBillToConsignee} = this.state;
        let lang = loadLanguage();
        return (
            <Card className="bill-to-confirm">
                <Grid
                    className="bill-to-title-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="bill-to-title-left" item>
                        <Grid className="consignee-icon-grid" item>
                            <Description />
                        </Grid>
                        <Grid className="bill-to-title" item>
                            <span>{T('invoiceTitle')}</span>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    className="consignee-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="consignee-grid" item xs={11}>
                        {/*<BasicInput title={'billToConsignee'} placeholder='' defalutValue={receiver} inputValid={this.props.handleChange} type='text' required='true'/>*/}
                        <SelectInput
                            testid="bill-to-consignee"
                            title={'billToConsignee'}
                            placeholder=""
                            list={stContactList}
                            value={billToConsignee}
                            defalutValue={receiver}
                            inputValid={this.handleSearch}
                            type="text"
                            required="true"
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="bill-to-phone-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    {/* <Grid item xs={1}></Grid> */}
                    <Grid className="bill-to-phone-grid" item xs={11}>
                        <BasicInput
                            title={'billToPhone'}
                            testid="bill-to-phone"
                            placeholder=""
                            defalutValue={receiverTel}
                            inputValid={this.props.handleChange}
                            isChangeBillToConsignee={isChangeBillToConsignee}
                            type="text"
                            required="true"
                            value={billToPhone}
                            disabled={billToPhoneDisable}
                            checkShipToPhone={true}
                            warningInfo={'please_input_correct_phone_number'}
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="bill-to-phone-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    {/* <Grid item xs={1}></Grid> */}
                    <Grid className="bill-to-phone-grid" item xs={11}>
                        <BasicOnInput
                            title={'billToEmail'}
                            testid="bill-to-email"
                            placeholder=""
                            defalutValue={invoiceReceiverEmail}
                            inputValid={this.props.handleChange}
                            isSearchChange={this.props.billToConsigneeSearch}
                            type="text"
                            required="true"
                            checkEmail="true"
                            value={billToEmail}
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="address-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid
                        className="address-title-grid"
                        item
                        xs={lang === 'EN' ? 3 : 2}>
                        <span>{T('order_address')}</span>
                    </Grid>
                    <Grid
                        className="address-grid"
                        item
                        xs={lang === 'EN' ? 9 : 10}>
                        <span>
                            {shipToInfo
                                ? util.formatAddress(
                                      shipToInfo.btCity,
                                      shipToInfo.btAddress,
                                      shipToInfo.btBuilding,
                                  )
                                : ''}
                        </span>
                    </Grid>
                </Grid>

                <Grid
                    className="invoice-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="invoice-label-grid" item xs={3}>
                        <span>{T('order_invoice_title')}</span>
                    </Grid>
                    <Grid className="invoice-title-grid" item xs={9}>
                        <span>
                            {shipToInfo ? shipToInfo.btInstitution : ''}
                        </span>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

export default BillToConfirm;
